import { FC, useCallback } from "react"
import { JsonViewer, JsonViewerOnChange } from "@textea/json-viewer"
import { cloneDeep, update } from "lodash"

export type InputJsonProps = {
  /**
   * Function that calculates the response and switches to output tab
   */
  calculate?: (value: any) => void
  /**
   * Default values provided to WASM
   */
  defaultValues: any
  setDefaultFormValues?: (value: any) => void
  resetDefaultValues?: (value: any) => void
  height?: "100%" | "32rem" | "28rem" | "24rem" | "16rem" | "8rem" | "4rem"
  removePadding?: boolean
}

export const InputJson: FC<InputJsonProps> = ({
  calculate,
  defaultValues,
  setDefaultFormValues = () => {},
  resetDefaultValues = () => {},
  height = "16rem",
  removePadding = false,
}) => {
  const heightClass = () => {
    switch (height) {
      case "100%":
        return "h-full"
      case "32rem":
        return "h-128"
      case "28rem":
        return "h-112"
      case "24rem":
        return "h-96"
      case "16rem":
        return "h-64"
      case "8rem":
        return "h-32"
      case "4rem":
        return "h-16"
    }
  }

  return (
    <>
      <div className={`border rounded max-w-xl mx-auto w-full overflow-auto p-2 ${heightClass()}`}>
        <JsonViewer
          value={defaultValues}
          editable={!!calculate}
          onChange={useCallback<JsonViewerOnChange>(
            (path, oldValue, newValue) => {
              const newValues = cloneDeep(defaultValues)

              update(newValues, path, () => {
                return newValue
              })

              setDefaultFormValues(newValues)
            },
            [defaultValues, setDefaultFormValues]
          )}
        />
      </div>

      {calculate && (
        <div className={`flex justify-center space-x-6 w-full ${removePadding ? "pb-0" : "pb-24"} lg:pb-0`}>
          <button
            className="bg-brand-light rounded text-white py-2 px-8 mt-3 text-sm"
            type="button"
            onClick={resetDefaultValues}
          >
            RESET
          </button>
          <button
            className="bg-brand-light rounded text-white py-2 px-8 mt-3 text-sm"
            type="button"
            onClick={() => calculate(defaultValues)}
          >
            CALCULATE
          </button>
        </div>
      )}
    </>
  )
}

